var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarbig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13744 0L4.48118 1.53373C4.75843 2.77071 5.70795 3.74655 6.9369 4.05749L8.27487 4.39603L6.9369 4.73456C5.70795 5.0455 4.75843 6.02134 4.48118 7.25833L4.13744 8.79205L3.79369 7.25833C3.51645 6.02134 2.56693 5.0455 1.33798 4.73456L0 4.39603L1.33798 4.05749C2.56693 3.74655 3.51645 2.77071 3.79369 1.53372L4.13744 0Z",
    fill: "#FD830C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarbig);
export default __webpack_public_path__ + "static/media/starbig.3b121d257af752da34e82ed8bbf34871.svg";
export { ForwardRef as ReactComponent };